if (!customElements.get('content-carousel-2')) {
  customElements.define('content-carousel-2', class ContentCarousel2 extends HTMLElement {
    constructor() {
      super()
    }
    countUp(trigger, counter) {
      const number = Number(counter.dataset.number)
      let current = 0

      const count = (increasement = 1) => {
        if (current <= number) {
          current = Math.min(number, current + increasement)
        }

        counter.textContent = current.toLocaleString('en-US')
      }

      const observer = new IntersectionObserver((el) => {
        if (el[0].isIntersecting) {
          const interval = setInterval(() => {
            if (current < number) {
              count(Math.max(1, Math.ceil(number / 100)))
            } else {
              clearInterval(interval)
            }
          }, 20)
        }
      }, { threshold: [0] })

      observer.observe(trigger)
    }

    connectedCallback() {
      const carousel = this.querySelector('.js-content-carousel-2-carousel')
      const navType = this.dataset.navType || 'progressbar'

      const swiper = new Swiper(carousel, {
        cssMode: false,
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: {
          forceToAxis: true
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
          draggable: true
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },
        on: {
          init: () => {
            this.querySelectorAll('.js-content-carousel-2-slide-number').forEach((item) => {
              this.countUp(item.parentNode, item)
            })
          }
        }
      })
    }
  })
}
